// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.loading-news,
.error-news {
  color: #666; 
  font-style: italic;
  padding: 20px 0; /* Increased padding */
  text-align: center;
}

.error-news {
  color: #dc3545; 
  font-weight: bold;
}

.news-feed-list {
  list-style: none;
  padding-left: 0;
  margin: 0; /* REMOVE max-width and auto margin */
}

.no-news-message {
  color: #666;
  font-style: italic;
  padding: 20px 0;
  text-align: center;
}

.news-feed-item {
  margin-bottom: 5px; /* Reduced spacing between items */
  border: 1px solid #e9ecef; /* Add border for card effect */
  border-radius: 8px; /* Rounded corners */
  overflow: hidden; /* Ensure image corners are rounded */
  background-color: #fff; /* White background for card */
  box-shadow: 0 2px 4px rgba(0,0,0,0.05); /* Subtle shadow */
  transition: box-shadow 0.2s ease-in-out;
}

.news-feed-item:hover {
   box-shadow: 0 4px 8px rgba(0,0,0,0.1); /* Enhance shadow on hover */
}

.news-feed-item:last-child {
  margin-bottom: 0;
}

.news-link-wrapper {
  display: flex; /* Use flexbox for layout */
  text-decoration: none;
  color: inherit; /* Inherit text color */
  align-items: center; /* Vertically center items */
}

.news-image {
  width: 100px; /* Fixed width for image */
  height: 100px; /* Fixed height */
  object-fit: cover; /* Cover the area, cropping if needed */
  flex-shrink: 0; /* Prevent image from shrinking */
  border-right: 1px solid #e9ecef; /* Separator line */
  align-self: center; /* Explicitly center vertically */
}

.news-image-placeholder {
  width: 100px;
  height: 100px;
  background-color: #f8f9fa; /* Light background for placeholder */
  display: flex;
  align-items: center;
  justify-content: center;
  color: #adb5bd; /* Muted text color */
  font-size: 0.8em;
  text-align: center;
  flex-shrink: 0;
  border-right: 1px solid #e9ecef;
  align-self: center; /* Explicitly center vertically */
}

.news-content {
  padding: 8px 10px; /* Reduced padding around text content */
  flex-grow: 1; /* Allow content to take remaining space */
  min-width: 0; /* Prevent content from overflowing */
}

.news-site-name {
  display: block;
  font-size: 0.8em;
  color: #6c757d; /* Muted color for site name */
  margin-bottom: 5px;
  text-transform: uppercase;
  font-weight: 600;
}

.news-title {
  margin: 0 0 8px 0; /* Adjust title margin */
  font-size: 1.1em; /* Slightly larger title */
  font-weight: 600;
  color: var(--Text-primary, #333); /* Use theme variable or default */
  line-height: 1.3;
}

.news-link-wrapper:hover .news-title {
   color: var(--link-hover-color, #0056b3); /* Change title color on hover */
}

.news-description {
  font-size: 0.9em;
  color: #495057; /* Slightly darker than site name */
  line-height: 1.5;
  margin: 0;
  /* Limit description lines (optional) */
  display: -webkit-box;
  -webkit-line-clamp: 2; /* Show max 2 lines */
  -webkit-box-orient: vertical;  
  overflow: hidden;
  text-overflow: ellipsis;
}

/* Optional: Style for publication date if added later */
/*
.news-pubdate {
  display: block;
  font-size: 0.8em;
  color: #6c757d; 
  margin-top: 8px;
}
*/

/* Responsive adjustments */
@media (max-width: 576px) {
  .news-image, .news-image-placeholder {
    width: 80px;
    height: 80px;
  }
  .news-title {
    font-size: 1em;
  }
   .news-description {
    font-size: 0.85em;
     -webkit-line-clamp: 2; /* Keep it short on mobile */
  }
  .news-content {
    padding: 8px; /* Adjust mobile padding */
  }
}`, "",{"version":3,"sources":["webpack://./src/components/NewsFeed/NewsFeed.css"],"names":[],"mappings":"AAAA;;EAEE,WAAW;EACX,kBAAkB;EAClB,eAAe,EAAE,sBAAsB;EACvC,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,SAAS,EAAE,qCAAqC;AAClD;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,kBAAkB,EAAE,kCAAkC;EACtD,yBAAyB,EAAE,+BAA+B;EAC1D,kBAAkB,EAAE,oBAAoB;EACxC,gBAAgB,EAAE,qCAAqC;EACvD,sBAAsB,EAAE,8BAA8B;EACtD,sCAAsC,EAAE,kBAAkB;EAC1D,uCAAuC;AACzC;;AAEA;GACG,qCAAqC,EAAE,4BAA4B;AACtE;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa,EAAE,2BAA2B;EAC1C,qBAAqB;EACrB,cAAc,EAAE,uBAAuB;EACvC,mBAAmB,EAAE,4BAA4B;AACnD;;AAEA;EACE,YAAY,EAAE,0BAA0B;EACxC,aAAa,EAAE,iBAAiB;EAChC,iBAAiB,EAAE,uCAAuC;EAC1D,cAAc,EAAE,iCAAiC;EACjD,+BAA+B,EAAE,mBAAmB;EACpD,kBAAkB,EAAE,iCAAiC;AACvD;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,yBAAyB,EAAE,qCAAqC;EAChE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc,EAAE,qBAAqB;EACrC,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,+BAA+B;EAC/B,kBAAkB,EAAE,iCAAiC;AACvD;;AAEA;EACE,iBAAiB,EAAE,wCAAwC;EAC3D,YAAY,EAAE,0CAA0C;EACxD,YAAY,EAAE,qCAAqC;AACrD;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,cAAc,EAAE,8BAA8B;EAC9C,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB,EAAE,wBAAwB;EAC3C,gBAAgB,EAAE,0BAA0B;EAC5C,gBAAgB;EAChB,gCAAgC,EAAE,kCAAkC;EACpE,gBAAgB;AAClB;;AAEA;GACG,uCAAuC,EAAE,gCAAgC;AAC5E;;AAEA;EACE,gBAAgB;EAChB,cAAc,EAAE,mCAAmC;EACnD,gBAAgB;EAChB,SAAS;EACT,uCAAuC;EACvC,oBAAoB;EACpB,qBAAqB,EAAE,qBAAqB;EAC5C,4BAA4B;EAC5B,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA,wDAAwD;AACxD;;;;;;;CAOC;;AAED,2BAA2B;AAC3B;EACE;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,cAAc;EAChB;GACC;IACC,iBAAiB;KAChB,qBAAqB,EAAE,4BAA4B;EACtD;EACA;IACE,YAAY,EAAE,0BAA0B;EAC1C;AACF","sourcesContent":[".loading-news,\n.error-news {\n  color: #666; \n  font-style: italic;\n  padding: 20px 0; /* Increased padding */\n  text-align: center;\n}\n\n.error-news {\n  color: #dc3545; \n  font-weight: bold;\n}\n\n.news-feed-list {\n  list-style: none;\n  padding-left: 0;\n  margin: 0; /* REMOVE max-width and auto margin */\n}\n\n.no-news-message {\n  color: #666;\n  font-style: italic;\n  padding: 20px 0;\n  text-align: center;\n}\n\n.news-feed-item {\n  margin-bottom: 5px; /* Reduced spacing between items */\n  border: 1px solid #e9ecef; /* Add border for card effect */\n  border-radius: 8px; /* Rounded corners */\n  overflow: hidden; /* Ensure image corners are rounded */\n  background-color: #fff; /* White background for card */\n  box-shadow: 0 2px 4px rgba(0,0,0,0.05); /* Subtle shadow */\n  transition: box-shadow 0.2s ease-in-out;\n}\n\n.news-feed-item:hover {\n   box-shadow: 0 4px 8px rgba(0,0,0,0.1); /* Enhance shadow on hover */\n}\n\n.news-feed-item:last-child {\n  margin-bottom: 0;\n}\n\n.news-link-wrapper {\n  display: flex; /* Use flexbox for layout */\n  text-decoration: none;\n  color: inherit; /* Inherit text color */\n  align-items: center; /* Vertically center items */\n}\n\n.news-image {\n  width: 100px; /* Fixed width for image */\n  height: 100px; /* Fixed height */\n  object-fit: cover; /* Cover the area, cropping if needed */\n  flex-shrink: 0; /* Prevent image from shrinking */\n  border-right: 1px solid #e9ecef; /* Separator line */\n  align-self: center; /* Explicitly center vertically */\n}\n\n.news-image-placeholder {\n  width: 100px;\n  height: 100px;\n  background-color: #f8f9fa; /* Light background for placeholder */\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #adb5bd; /* Muted text color */\n  font-size: 0.8em;\n  text-align: center;\n  flex-shrink: 0;\n  border-right: 1px solid #e9ecef;\n  align-self: center; /* Explicitly center vertically */\n}\n\n.news-content {\n  padding: 8px 10px; /* Reduced padding around text content */\n  flex-grow: 1; /* Allow content to take remaining space */\n  min-width: 0; /* Prevent content from overflowing */\n}\n\n.news-site-name {\n  display: block;\n  font-size: 0.8em;\n  color: #6c757d; /* Muted color for site name */\n  margin-bottom: 5px;\n  text-transform: uppercase;\n  font-weight: 600;\n}\n\n.news-title {\n  margin: 0 0 8px 0; /* Adjust title margin */\n  font-size: 1.1em; /* Slightly larger title */\n  font-weight: 600;\n  color: var(--Text-primary, #333); /* Use theme variable or default */\n  line-height: 1.3;\n}\n\n.news-link-wrapper:hover .news-title {\n   color: var(--link-hover-color, #0056b3); /* Change title color on hover */\n}\n\n.news-description {\n  font-size: 0.9em;\n  color: #495057; /* Slightly darker than site name */\n  line-height: 1.5;\n  margin: 0;\n  /* Limit description lines (optional) */\n  display: -webkit-box;\n  -webkit-line-clamp: 2; /* Show max 2 lines */\n  -webkit-box-orient: vertical;  \n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n/* Optional: Style for publication date if added later */\n/*\n.news-pubdate {\n  display: block;\n  font-size: 0.8em;\n  color: #6c757d; \n  margin-top: 8px;\n}\n*/\n\n/* Responsive adjustments */\n@media (max-width: 576px) {\n  .news-image, .news-image-placeholder {\n    width: 80px;\n    height: 80px;\n  }\n  .news-title {\n    font-size: 1em;\n  }\n   .news-description {\n    font-size: 0.85em;\n     -webkit-line-clamp: 2; /* Keep it short on mobile */\n  }\n  .news-content {\n    padding: 8px; /* Adjust mobile padding */\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
